import Vue from 'vue';
import { fetchCompanyBranches as fetchCompanyBranchesApi } from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  companyBranchesData: {
    isLoading: false,
  },
  companyBranches: {},
};

const mutations = {
  SET_LOADING_COMPANY_BRANCHES_DATA(state, isLoading) {
    state.companyBranchesData.isLoading = isLoading;
  },
  SET_COMPANY_BRANCHES_DATA(state, { companyId, data }) {
    Vue.set(state.companyBranches, companyId, {
      items: data,
      cachedAt: Date.now(),
    });
  },
};

const actions = {
  async fetchCompanyBranches({ commit, dispatch }, companyId) {
    const existingCompanyBranches = state.companyBranches[companyId];
    if (existingCompanyBranches) {
      return existingCompanyBranches.items;
    }

    commit('SET_LOADING_COMPANY_BRANCHES_DATA', true);

    try {
      const response = await fetchCompanyBranchesApi(companyId);
      commit('SET_COMPANY_BRANCHES_DATA', {
        companyId,
        data: response,
      });

      return response;
    } catch (error) {
      const errorMessage = error.response?.message
        || error.message
        || 'Не вдалося завантажити інформацію про філії компанії';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error,
          title: 'Не вдалося завантажити інформацію про філії компанії',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_COMPANY_BRANCHES_DATA', false);
    }
  },
};

const getters = {
  isLoadingCompanyBranchesData: state => state.companyBranchesData.isLoading,
  getCompanyBranches: state => companyId => state.companyBranches[companyId]?.items || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
